{
  "AUTOMATION": {
    "HEADER": "Автоматизация",
    "DESCRIPTION": "Автоматизация позволяет заменить и упростить процессы, требующие ручной работы, такие как добавление меток и назначение диалогов наиболее подходящим агентам. Это помогает команде сосредоточиться на ключевых задачах и сократить время на рутину.",
    "LEARN_MORE": "Узнать больше об автоматизации",
    "COUNT": "{n} автоматизация | {n} автоматизаций",
    "HEADER_BTN_TXT": "Создать автоматизацию",
    "LOADING": "Получение правил автоматизации",
    "SEARCH_PLACEHOLDER": "Поиск правил автоматизации...",
    "NO_RESULTS": "Не найдено правил автоматизации, соответствующих вашему запросу",
    "ADD": {
      "TITLE": "Добавить правило автоматизации",
      "SUBMIT": "Создать",
      "CANCEL_BUTTON_TEXT": "Отменить",
      "FORM": {
        "NAME": {
          "LABEL": "Название правила",
          "PLACEHOLDER": "Введите название правила",
          "ERROR": "Необходимо указать название"
        },
        "DESC": {
          "LABEL": "Описание",
          "PLACEHOLDER": "Введите описание правила",
          "ERROR": "Необходимо указать описание"
        },
        "EVENT": {
          "LABEL": "Событие",
          "PLACEHOLDER": "Пожалуйста, выберите одно",
          "ERROR": "Необходимо указать событие"
        },
        "CONDITIONS": {
          "LABEL": "Условия"
        },
        "ACTIONS": {
          "LABEL": "Действия"
        }
      },
      "CONDITION_BUTTON_LABEL": "Добавить условие",
      "ACTION_BUTTON_LABEL": "Добавить действие",
      "API": {
        "SUCCESS_MESSAGE": "Правило автоматизации успешно добавлено",
        "ERROR_MESSAGE": "Не удалось создать правило автоматизации. Пожалуйста, попробуйте позже"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Название",
        "ACTIVE": "Активно",
        "CREATED_ON": "Дата создания",
        "ACTIONS": "Действия"
      },
      "404": "Правила автоматизации не найдены"
    },
    "DELETE": {
      "TITLE": "Удалить правило автоматизации",
      "SUBMIT": "Удалить",
      "CANCEL_BUTTON_TEXT": "Отменить",
      "CONFIRM": {
        "TITLE": "Подтвердите удаление",
        "MESSAGE": "Вы уверены, что хотите удалить ",
        "YES": "Да, удалить ",
        "NO": "Нет, оставить "
      },
      "API": {
        "SUCCESS_MESSAGE": "Правило автоматизации успешно удалено",
        "ERROR_MESSAGE": "Не удалось удалить правило автоматизации. Пожалуйста, попробуйте позже"
      }
    },
    "EDIT": {
      "TITLE": "Редактировать правило автоматизации",
      "SUBMIT": "Обновить",
      "CANCEL_BUTTON_TEXT": "Отменить",
      "API": {
        "SUCCESS_MESSAGE": "Правило автоматизации успешно обновлено",
        "ERROR_MESSAGE": "Не удалось обновить правило автоматизации. Пожалуйста, попробуйте позже"
      }
    },
    "CLONE": {
      "TOOLTIP": "Дублировать",
      "API": {
        "SUCCESS_MESSAGE": "Правило автоматизации успешно дублировано",
        "ERROR_MESSAGE": "Не удалось дублировать правило автоматизации. Пожалуйста, попробуйте позже"
      }
    },
    "FORM": {
      "EDIT": "Редактировать",
      "CREATE": "Создать",
      "DELETE": "Удалить",
      "CANCEL": "Отменить",
      "RESET_MESSAGE": "Изменение типа события сбросит условия и события, добавленные вами ниже"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Для сохранения необходимо указать хотя бы одно условие",
      "CONTACT_CUSTOM_ATTR_LABEL": "Пользовательские атрибуты контакта",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Пользовательские атрибуты диалога"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Для сохранения необходимо указать хотя бы одно действие",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Введите сообщение",
      "TEAM_DROPDOWN_PLACEHOLDER": "Выберите команды",
      "EMAIL_INPUT_PLACEHOLDER": "Введите адрес электронной почты",
      "URL_INPUT_PLACEHOLDER": "Введите URL-адрес"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Включить правило автоматизации",
      "DEACTIVATION_TITLE": "Отключить правило автоматизации",
      "ACTIVATION_DESCRIPTION": "Это действие включит правило автоматизации «{automationName}». Продолжить?",
      "DEACTIVATION_DESCRIPTION": "Это действие отключит правило автоматизации «{automationName}». Продолжить?",
      "ACTIVATION_SUCCESFUL": "Правило автоматизации успешно включено",
      "DEACTIVATION_SUCCESFUL": "Правило автоматизации успешно отключено",
      "ACTIVATION_ERROR": "Не удалось включить правило автоматизации. Пожалуйста, попробуйте позже",
      "DEACTIVATION_ERROR": "Не удалось отключить правило автоматизации. Пожалуйста, попробуйте позже",
      "CONFIRMATION_LABEL": "Да",
      "CANCEL_LABEL": "Нет"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Не удалось загрузить вложение. Пожалуйста, попробуйте ещё раз",
      "LABEL_IDLE": "Загрузить вложение",
      "LABEL_UPLOADING": "Загрузка...",
      "LABEL_UPLOADED": "Успешно загружено",
      "LABEL_UPLOAD_FAILED": "Ошибка загрузки"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Необходимо указать ключ атрибута",
      "FILTER_OPERATOR_REQUIRED": "Необходимо указать оператор фильтра",
      "VALUE_REQUIRED": "Необходимо указать значение",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Значение должно быть в диапазоне от 1 до 998",
      "ACTION_PARAMETERS_REQUIRED": "Необходимо указать параметры действия",
      "ATLEAST_ONE_CONDITION_REQUIRED": "Необходимо указать хотя бы одно условие",
      "ATLEAST_ONE_ACTION_REQUIRED": "Необходимо указать хотя бы одно действие"
    },
    "NONE_OPTION": "Нет",
    "LAST_RESPONDING_AGENT": "Последний ответ агента",
    "EVENTS": {
      "CONVERSATION_CREATED": "Диалог создан",
      "CONVERSATION_UPDATED": "Диалог обновлён",
      "MESSAGE_CREATED": "Сообщение создано",
      "CONVERSATION_RESOLVED": "Диалог завершён",
      "CONVERSATION_OPENED": "Диалог открыт"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Назначить агента",
      "ASSIGN_TEAM": "Назначить команду",
      "REMOVE_ASSIGNED_AGENT": "Remove Assigned Agent",
      "REMOVE_ASSIGNED_TEAM": "Удалить назначенную команду",
      "ADD_LABEL": "Добавить метку",
      "REMOVE_LABEL": "Удалить метку",
      "SEND_EMAIL_TO_TEAM": "Отправить Email команде",
      "SEND_EMAIL_TRANSCRIPT": "Отправить историю переписки по Email",
      "MUTE_CONVERSATION": "Отключить уведомления",
      "SNOOZE_CONVERSATION": "Отложить диалог",
      "RESOLVE_CONVERSATION": "Завершить диалог",
      "SEND_WEBHOOK_EVENT": "Отправить Webhook-событие",
      "SEND_ATTACHMENT": "Отправить вложение",
      "SEND_MESSAGE": "Отправить сообщение",
      "ADD_PRIVATE_NOTE": "Добавить приватную заметку",
      "CHANGE_PRIORITY": "Изменить приоритет",
      "ADD_SLA": "Добавить SLA",
      "OPEN_CONVERSATION": "Открыть диалог",
      "PENDING_CONVERSATION": "Пометить разговор как ожидающий"
    },
    "MESSAGE_TYPES": {
      "INCOMING": "Входящее сообщение",
      "OUTGOING": "Исходящее сообщение"
    },
    "PRIORITY_TYPES": {
      "NONE": "Нет",
      "LOW": "Низкий",
      "MEDIUM": "Средний",
      "HIGH": "Высокий",
      "URGENT": "Срочный"
    },
    "ATTRIBUTES": {
      "MESSAGE_TYPE": "Тип сообщения",
      "PRIVATE_NOTE": "Личная заметка",
      "MESSAGE_CONTAINS": "Сообщение содержит",
      "EMAIL": "Email",
      "INBOX": "Источник",
      "CONVERSATION_LANGUAGE": "Язык диалога",
      "PHONE_NUMBER": "Номер телефона",
      "STATUS": "Статус",
      "BROWSER_LANGUAGE": "Язык браузера",
      "MAIL_SUBJECT": "Тема письма",
      "COUNTRY_NAME": "Страна",
      "COMPANY_NAME": "Компания",
      "REFERER_LINK": "Источник перехода",
      "ASSIGNEE_NAME": "Назначенный агент",
      "TEAM_NAME": "Команда",
      "PRIORITY": "Приоритет",
      "LABELS": "Метки"
    }
  }
}
